import { ALLACCESS, ESSENTIALS, FREE } from "@/consts/bundles";
import {
  fetchAll,
  fetchLearnCertifications,
} from "@/services/catalogService/certifications";
import { getRevupCampaignsBundles } from "@/services/catalogService/contentBundle";
import { retrieveTopicContent } from "@/services/middlewareService/topics";
import { freeContents } from "@/services/unauthService/freeContents";

export default {
  namespaced: true,
  state: {
    contentBundles: [],
    authorizedContent: [],
    cachedTopicsContent: {},
    certifications: [],
    learCertifications: [],
    revupCampaigns: [],
    layoutView: "Grid",
    cardView: "Grid",
  },
  getters: {
    certifications: (state: any) => state.certifications,
    learCertifications: (state: any) => state.learCertifications,
    contentBundles: (state: any) => state.contentBundles,
    freeBundle: (state: any) => {
      if (state.contentBundles.length === 0) return null;
      return state.contentBundles.filter((bundle: any) => {
        return bundle.name === FREE;
      })[0];
    },
    essentialsBundle: (state: any) => {
      if (state.contentBundles.length === 0) return null;
      return state.contentBundles.filter((bundle: any) => {
        return bundle.name === ESSENTIALS;
      })[0];
    },
    allAccessBundle: (state: any) => {
      if (state.contentBundles.length === 0) return null;
      return state.contentBundles.filter((bundle: any) => {
        return bundle.name === ALLACCESS;
      })[0];
    },
    freeId: (state: any, getters: any) => {
      if (getters.freeBundle === null || getters.freeBundle === undefined)
        return 0;
      return getters.freeBundle.id;
    },
    essentialsId: (state: any, getters: any) => {
      if (getters.essentialsBundle === null) return 0;
      return getters.essentialsBundle?.id;
    },
    allAccessId: (state: any, getters: any) => {
      if (getters.allAccessBundle === null) return 0;
      return getters.allAccessBundle?.id;
    },
    essentialsProductId: (state: any, getters: any) => {
      if (getters.essentialsBundle === null) return 0;
      return getters.essentialsBundle?.productGuid;
    },
    allAccessProductId: (state: any, getters: any) => {
      if (getters.allAccessBundle === null) return 0;
      return getters.allAccessBundle?.productGuid;
    },
    authorizedContent:
      (state: any) =>
      (guid: string): boolean => {
        if (state.authorizedContent.length === 0) return false;
        return state.authorizedContent.includes(guid);
      },
    topicsContent:
      (state: any) =>
      (topic: string): any => {
        return state.cachedTopicsContent[topic];
      },
    revupCampaigns: (state: any) => state.revupCampaigns,
    layoutView: (state: any) => state.layoutView,
    cardView: (state: any) => state.cardView,
  },
  mutations: {
    setCertifications(state: any, value: any) {
      state.certifications = value;
    },
    setLearnCertifications(state: any, value: any) {
      state.learCertifications = value;
    },
    setContentBundle(state: any, value: any) {
      const plans = value
        .filter((bundle: any) => {
          return !bundle.is_single;
        })
        .map((bundle: any) => {
          bundle.id = bundle.content_bundle_id[0];
          return bundle;
        });
      state.contentBundles = plans;
    },
    setAuthorizedContent(state: any, value: any) {
      state.authorizedContent = value;
    },
    setTopicsContent(state: any, value: any) {
      state.cachedTopicsContent[value.topic as string] = value.response;
    },
    setRevupBundles(state: any, bundles: any) {
      state.revupCampaigns = bundles;
    },
    setLayoutView(state: any, value: any) {
      state.layoutView = value;
    },
    setCardView(state: any, value: any) {
      state.cardView = value;
    },
  },
  actions: {
    fetchCertifications({ commit }: any) {
      fetchAll()
        .then((result: any) => {
          commit("setCertifications", result.data);
        })
        .catch(() => {
          // intentional
        });
    },
    fetchLearnCertification({ commit }: any) {
      fetchLearnCertifications()
        .then((result: any) => {
          commit("setLearnCertifications", result.data);
        })
        .catch(() => {
          // intentional
        });
    },
    getFreeContent({ commit }: any, type: string) {
      freeContents()
        .then((response: any) => {
          if (response.userEntitlements) {
            commit("setAuthorizedContent", response.userEntitlements);
          }
        })
        .catch(() => {
          // intentional
        });
    },
    fetchRevupBundles({ commit }: any) {
      getRevupCampaignsBundles()
        .then((result: any) => {
          commit("setRevupBundles", result.content_bundles);
        })
        .catch((error: any) => {
          console.error("Failed to fetch RevUp bundles:", error);
        });
    },
    async fetchTopicContents({ getters, commit }: any, topic?: string) {
      const storedTopic = topic ?? "all";
      const cachedContent = getters.topicsContent(storedTopic);
      if (cachedContent) {
        return cachedContent;
      }
      const res = await retrieveTopicContent(topic);
      commit("setTopicsContent", { topic: storedTopic, response: res });
      return res;
    },
  },
};
